import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  ourClientsMainContent: drilldownData["ourClientsMainContent"].map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),
  localClients: drilldownData["localClients"]?.map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),

  internationalClients: drilldownData["internationalClients"]?.map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),
};
